import { render } from "./CategoriesSkeleton.vue?vue&type=template&id=3adcab9f"
const script = {}

import exportComponent from "/var/www/coursat-zain-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__